import axios from "../../axios/axios";

import * as apis from "../../apis";
import * as errors from "../../errors"
import * as successes from "../../successes"

import {CLOSE_CUSTOMER_MODAL} from "./ui";

import {getAxiosTokenConfig} from "../../helpers";

import {notifyError, notifySuccess} from "../../toast-notifications";
import { getReservations } from "./reservations";


// GET CUSTOMERS
export const GET_CUSTOMERS_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS";
export const GET_CUSTOMERS_ERROR = "GET_CUSTOMERS_ERROR";

export const getCustomersRequest = () => {
    return {
        type: GET_CUSTOMERS_REQUEST,
        loading: true
    };
};
export const getCustomersSuccess = (customers) => {
    return {
        type: GET_CUSTOMERS_SUCCESS,
        loading: false,
        error: null,
        customers
    };
};
export const getCustomersError = (error) => {
    return {
        type: GET_CUSTOMERS_ERROR,
        loading: false,
        error
    };
};
export const getCustomers = () => {
    return dispatch => {
        dispatch(getCustomersRequest());
        axios.get(apis.GET_CUSTOMERS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getCustomersSuccess(response.data));
            })
            .catch(error => {
                dispatch(getCustomersError(errors.GET_CUSTOMERS_ERROR));
                notifyError(errors.GET_CUSTOMERS_ERROR);
            });
    };
};

// ADD CUSTOMER
export const ADD_CUSTOMER_REQUEST = "ADD_CUSTOMER_REQUEST";
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS";
export const ADD_CUSTOMER_ERROR = "ADD_CUSTOMER_ERROR";

export const addCustomerRequest = () => {
    return {
        type: ADD_CUSTOMER_REQUEST,
        loading: true
    };
};
export const addCustomerSuccess = (customer) => {
    return {
        type: ADD_CUSTOMER_SUCCESS,
        loading: false,
        error: null,
        customer
    };
};
export const addCustomerError = (error) => {
    return {
        type: ADD_CUSTOMER_ERROR,
        loading: false,
        error
    };
};
export const addCustomer = (customer) => {
    return dispatch => {
        dispatch(addCustomerRequest());
        axios.post(apis.ADD_CUSTOMER_API, customer, getAxiosTokenConfig())
            .then(response => {
                dispatch(addCustomerSuccess(response.data));
                notifySuccess(successes.ADD_CUSTOMER_SUCCESS);
            })
            .catch(error => {
                dispatch(addCustomerError(errors.ADD_CUSTOMER_ERROR));
                notifyError(errors.ADD_CUSTOMER_ERROR);
            })
            .finally( res => {
            dispatch({type: CLOSE_CUSTOMER_MODAL});
            });
    };
};

// DELETE CUSTOMER
export const DELETE_CUSTOMER_REQUEST = "DELETE_CUSTOMER_REQUEST";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_ERROR = "DELETE_CUSTOMER_ERROR";

export const deleteCustomerRequest = () => {
    return {
        type: DELETE_CUSTOMER_REQUEST,
        loading: true
    };
};
export const deleteCustomerSuccess = (customerId) => {
    return {
        type: DELETE_CUSTOMER_SUCCESS,
        loading: false,
        error: null,
        customerId
    };
};
export const deleteCustomerError = (error) => {
    return {
        type: DELETE_CUSTOMER_ERROR,
        loading: false,
        error
    };
};
export const deleteCustomer = (id) => {
    return dispatch => {
        dispatch(deleteCustomerRequest());
        return new Promise((resolve, reject) => {
            axios.delete(apis.DELETE_CUSTOMER_API + id + "/", getAxiosTokenConfig())
                .then(response => {
                    dispatch(deleteCustomerSuccess(id));
                    notifySuccess(successes.DELETE_CUSTOMER_SUCCESS);
                    resolve();
                })
                .catch(error => {
                    dispatch(deleteCustomerError(error));
                    notifyError(errors.DELETE_CUSTOMER_ERROR);
                    reject();
                });
        });
    };
};

// BULK DELETE CUSTOMER
export const BULK_DELETE_CUSTOMER_REQUEST = "BULK_DELETE_CUSTOMER_REQUEST";
export const BULK_DELETE_CUSTOMER_SUCCESS = "BULK_DELETE_CUSTOMER_SUCCESS";
export const BULK_DELETE_CUSTOMER_ERROR = "BULK_DELETE_CUSTOMER_ERROR";

export const bulkDeleteCustomerRequest = () => {
    return {
        type: BULK_DELETE_CUSTOMER_REQUEST,
        loading: true
    };
};
export const bulkDeleteCustomerSuccess = (customerIds) => {
    return {
        type: BULK_DELETE_CUSTOMER_SUCCESS,
        loading: false,
        error: null,
        customerIds
    };
};
export const bulkDeleteCustomerError = (error) => {
    return {
        type: BULK_DELETE_CUSTOMER_ERROR,
        loading: false,
        error
    };
};
export const bulkDeleteCustomer = (ids = []) => {
    return dispatch => {
        dispatch(bulkDeleteCustomerRequest());
        return new Promise((resolve, reject) => {
            axios.delete(apis.DELETE_CUSTOMER_API + "bulk/", { data: ids, ...getAxiosTokenConfig() })
                .then(response => {
                    dispatch(bulkDeleteCustomerSuccess(ids));
                    notifySuccess(successes.BULK_DELETE_CUSTOMER_SUCCESS);
                    resolve();
                })
                .catch(error => {
                    dispatch(bulkDeleteCustomerError(error));
                    notifyError(errors.BULK_DELETE_CUSTOMER_ERROR);
                    reject();
                });
        });
    };
};

// UPDATE CUSTOMER
export const UPDATE_CUSTOMER_REQUEST = "UPDATE_CUSTOMER_REQUEST";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_ERROR = "UPDATE_CUSTOMER_ERROR";

export const updateCustomerRequest = () => {
    return {
        type: UPDATE_CUSTOMER_REQUEST,
        loading: true
    };
};
export const updateCustomerSuccess = (customer) => {
    return {
        type: UPDATE_CUSTOMER_SUCCESS,
        loading: false,
        error: null,
        customer
    };
};
export const updateCustomerError = (error) => {
    return {
        type: UPDATE_CUSTOMER_ERROR,
        loading: false,
        error
    };
};
export const updateCustomer = (customer) => {
    return (dispatch, getState) => {
        const currentCustomer = getState().customersReducer.currentCustomer;
        dispatch(updateCustomerRequest());
        axios.patch(apis.UPDATE_CUSTOMER_API + customer.id + "/", customer, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateCustomerSuccess(response.data));
                if(currentCustomer.id){
                    dispatch(setCurrentCustomer(currentCustomer.id));
                }
                notifySuccess(successes.UPDATE_CUSTOMER_SUCCESS);
            })
            .catch(error => {
                dispatch(updateCustomerError(error));
                notifyError(errors.UPDATE_CUSTOMER_ERROR);
            })
            .finally( res => {
                dispatch({type: CLOSE_CUSTOMER_MODAL});
            });
    };
};

// GET CUSTOMER RESERVATIONS
export const GET_CUSTOMER_RESERVATIONS_REQUEST = "GET_CUSTOMER_RESERVATIONS_REQUEST";
export const GET_CUSTOMER_RESERVATIONS_SUCCESS = "GET_CUSTOMER_RESERVATIONS_SUCCESS";
export const GET_CUSTOMER_RESERVATIONS_ERROR = "GET_CUSTOMER_RESERVATIONS_ERROR";

export const getCustomerReservationsRequest = () => {
    return {
        type: GET_CUSTOMER_RESERVATIONS_REQUEST,
        loading: true
    };
};
export const getCustomerReservationsSuccess = (reservations) => {
    return {
        type: GET_CUSTOMER_RESERVATIONS_SUCCESS,
        loading: false,
        error: null,
        reservations
    };
};
export const getCustomerReservationsError = (error) => {
    return {
        type: GET_CUSTOMER_RESERVATIONS_ERROR,
        loading: false,
        error
    };
};

export const getCustomerReservations = (customer) => {
    return dispatch => {
        dispatch(getCustomerReservationsRequest());
        return new Promise((resolve, reject) => {
            axios.get(apis.GET_CUSTOMERS_API + "/" + customer.id + "/reservations/", getAxiosTokenConfig())
                .then(response => {
                    dispatch(getCustomerReservationsSuccess(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    dispatch(getCustomerReservationsError(errors.GET_CUSTOMER_RESERVATIONS_ERROR));
                    notifyError(errors.GET_CUSTOMER_RESERVATIONS_ERROR);
                    reject();
                });
        });
    };
};

// GET CUSTOMER DUPLICATES
export const GET_CUSTOMER_DUPLICATES_REQUEST = "GET_CUSTOMER_DUPLICATES_REQUEST";
export const GET_CUSTOMER_DUPLICATES_SUCCESS = "GET_CUSTOMER_DUPLICATES_SUCCESS";
export const GET_CUSTOMER_DUPLICATES_ERROR = "GET_CUSTOMER_DUPLICATES_ERROR";

export const getCustomerDuplicatesRequest = () => {
    return {
        type: GET_CUSTOMER_DUPLICATES_REQUEST,
        loading: true
    };
};
export const getCustomerDuplicatesSuccess = (duplicates) => {
    return {
        type: GET_CUSTOMER_DUPLICATES_SUCCESS,
        loading: false,
        error: null,
        duplicates
    };
};
export const getCustomerDuplicatesError = (error) => {
    return {
        type: GET_CUSTOMER_DUPLICATES_ERROR,
        loading: false,
        error
    };
};
export const getCustomerDuplicates = (field='email') => {
    return dispatch => {
        dispatch(getCustomerDuplicatesRequest());
        return new Promise((resolve, reject) => {
            axios.get(apis.GET_CUSTOMERS_API + "duplicates?field="+field, getAxiosTokenConfig())
                .then(response => {
                    dispatch(getCustomerDuplicatesSuccess(response.data));
                    resolve(response.data);
                })
                .catch(error => {
                    dispatch(getCustomerDuplicatesError(errors.GET_CUSTOMER_DUPLICATES_ERROR));
                    notifyError(errors.GET_CUSTOMER_DUPLICATES_ERROR);
                    reject();
                });
        });
    };
};

export const SET_CURRENT_CUSTOMER = "SET_CURRENT_CUSTOMER";

export const setCurrentCustomer = (id) => {
    return (dispatch, getState) => {
        const currentCustomer = getState().customersReducer.customers.find(c => c.id === id);
        dispatch({
            type: SET_CURRENT_CUSTOMER,
            currentCustomer,
        });
    }
}

export const FUSE_CUSTOMERS_REQUEST = "FUSE_CUSTOMERS_REQUEST";
export const FUSE_CUSTOMERS_SUCCESS = "FUSE_CUSTOMERS_SUCCESS";
export const FUSE_CUSTOMERS_ERROR = "FUSE_CUSTOMERS_ERROR";

export const fuseCustomersRequest = () => {
    return {
        type: FUSE_CUSTOMERS_REQUEST,
    };
};
export const fuseCustomersSuccess = (fused) => {
    return {
        type: FUSE_CUSTOMERS_SUCCESS,
        fused
    };
};
export const fuseCustomersError = (error) => {
    return {
        type: FUSE_CUSTOMERS_ERROR,
        error
    };
};
export const fuseCustomers = (target, members = []) => {

    const data = { target, members };

    return dispatch => {
        dispatch(fuseCustomersRequest());
        axios.post(apis.UPDATE_CUSTOMER_API + "fuse/", data, getAxiosTokenConfig())
            .then(response => {
                dispatch(fuseCustomersSuccess(members));
                dispatch(getReservations());
                notifySuccess(successes.FUSE_CUSTOMERS_SUCCESS);
            })
            .catch(error => {
                dispatch(fuseCustomersError(errors.FUSE_CUSTOMERS_ERROR));
                notifyError(errors.FUSE_CUSTOMERS_ERROR);
            });
    };
};

export const BULK_FUSE_CUSTOMERS_REQUEST = "BULK_FUSE_CUSTOMERS_REQUEST";
export const BULK_FUSE_CUSTOMERS_SUCCESS = "BULK_FUSE_CUSTOMERS_SUCCESS";
export const BULK_FUSE_CUSTOMERS_ERROR = "BULK_FUSE_CUSTOMERS_ERROR";

export const bulkFuseCustomersRequest = () => {
    return {
        type: BULK_FUSE_CUSTOMERS_REQUEST,
    };
};
export const bulkFuseCustomersSuccess = (fused) => {
    return {
        type: BULK_FUSE_CUSTOMERS_SUCCESS,
        fused
    };
};
export const bulkFuseCustomersError = (error) => {
    return {
        type: BULK_FUSE_CUSTOMERS_ERROR,
        error
    };
};
export const bulkFuseCustomers = (bulk = []) => {
    return dispatch => {
        dispatch(bulkFuseCustomersRequest());
        axios.post(apis.UPDATE_CUSTOMER_API + "fuse/bulk/", bulk, getAxiosTokenConfig())
            .then(response => {
                dispatch(bulkFuseCustomersSuccess(bulk.flat().map(fusion => fusion.members).flat()));
                dispatch(getReservations());
                notifySuccess(successes.FUSE_CUSTOMERS_SUCCESS);
            })
            .catch(error => {
                dispatch(bulkFuseCustomersError(errors.FUSE_CUSTOMERS_ERROR));
                notifyError(errors.FUSE_CUSTOMERS_ERROR);
            });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/customers.js